import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { OAuthModule } from 'angular-oauth2-oidc';

import { WebserviceService } from './webservice.service';
import { WebserviceErrorInterceptor } from './webservice-error.interceptor';


@NgModule({
	imports: [ HttpClientModule, OAuthModule ],
	providers: [
		WebserviceService,
		{ provide: HTTP_INTERCEPTORS, useClass: WebserviceErrorInterceptor, multi: true },
	],
})
export class WebserviceModule {}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/services/webservice/webservice.module.ts